<template>
  <div v-if="showFlag" class="download-banner-box" :class="positionCls">
    <div class="download-banner">
      <div class="fix-l" @click="closeBannerAction">
        <div class="close-box">
          <div class="close"></div>
        </div>
      </div>
      <div class="fluid-wrap">
        <div class="fluid-box">
          <div class="logo-box">
            <img class="logo" :src="logoImage" />
          </div>
          <div class="text-box">
            <p class="text title">{{downloadData.title}}</p>
            <p class="text content">{{downloadData.describe}}</p>
          </div>
        </div>
      </div>
      <div class="fix-r">
        <open-app class="download-btn" :text="text" :link="link" :pageType="pageType"/>
        <!-- <a href="javascript:;" class="download-btn j_download">立即下载</a> -->
      </div>
    </div>
    <!--版本号和更新时间去掉，亚芳要求，20241226-->
    <!-- <div class="download-prompt">开发者: Shanghai Yi-pai E-commerce Co.,Ltd&nbsp;&nbsp;&nbsp;版本号: 5.2.2&nbsp;&nbsp;&nbsp;<span class="prompt-link" @click="permissionAction">用户权限</span>&nbsp;&nbsp;&nbsp;<span class="prompt-link" @click="ruleAction">隐私条款</span></div> -->
    <div class="download-prompt">开发者: Shanghai Yi-pai E-commerce Co.,Ltd&nbsp;&nbsp;&nbsp;<span class="prompt-link" @click="permissionAction">用户权限</span>&nbsp;&nbsp;&nbsp;<span class="prompt-link" @click="ruleAction">隐私条款</span></div>
  </div>
</template>


<script>
  import querystring from 'query-string'
  import { app } from '@beastshop/browser'
  import { ensure_protocol } from '@beastshop/url-util'
  import axios from '@/axios-mock'

  import openApp from '../open-app'

  // import { testData } from './test/data.js'


  const search = location.search.slice(1)
  const urlParams = querystring.parse(search)
  let iParam = urlParams._i
  let aParam = urlParams._a
  const logoImage = ensure_protocol("http://img.thebeastshop.com/app/activity/download/download-logo.png")
  const pageData = {
    index: {
      _i: 'JxdoMh',
      _a: '1UNxBd',
    },
    list: {
      _i: 'wNV9At',
      _a: 'dE5IZt',
    },
    product: {
      _i: '10UtQd',
      _a: 'xJFBxt',
    },
    article: {
      _i: 'JZN9k4',
      _a: 'wpE5ss',
    },
    story: {
      _i: 'c8ABVd',
      _a: 'J5gU9g',
    },
  }

  export default {
    name: 'download-banner',
    props: {
      position: {
        type: String,
        default: 'bottom',
      },
      pageType: {
        type: String,
        default: '',
      },
      link: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '立即下载'
      },
      // talkingData: {
      //   type: Object,
      //   default: null
      // }
    },

    data () {
      return {
        showFlag: false,
        logoImage: logoImage,
        downloadData: null,
        talkingData: null
      }
    },

    components: {
      openApp
    },

    mounted () {
    },

    created () {
      if(app()) {
        this.showFlag = false
        return
      }

      //抖音环境 关闭下载条
      let dySession = sessionStorage.getItem('dy-downloader')
      console.log(dySession, 'dysession')
      if(dySession === 'close') {
        this.showFlag = false
        this.$emit('banner-close')
        return
      }

      let storage = this.getStorage("time")
      if(!storage) {//过期或者没缓存
        this.getBanner()
      } else {
        this.$emit('banner-close')
      }
      // this.formatData(testData)
    },

    computed: {
      positionCls () {
        if(this.position === 'top') {
          return {
            'top': true
          }
        }
        if(this.position === 'bottom') {
          return {
            'bottom': true
          }
        }
      },
    },

    methods: {
      getBanner () {
        this.getBannerData()
        .then(data => {
          if(data) {
            this.formatData(data)
          }
        })
        .catch(err => {
          console.log(err)
          return
        })
      },

      formatData (data) {
        this.downloadData = data
        let pageObj = pageData[this.pageType]
        if(!iParam && pageObj) {
          iParam = pageObj['_i']
        }
        if(!aParam && pageObj) {
          aParam = pageObj['_a']
        }
        this.talkingData = {
          _i: iParam,
          _a: aParam
        }
        this.showFlag = true
      },

      getBannerData () {
        return axios({
          url: `/app/config/downloadContext`,
          method: 'GET'
        })
        .then(({
          code,
          data
        }) => {
          return Promise.resolve(data)
        })
        .catch(err => {
          return Promise.reject(err)
        })
      },

      closeBannerAction () {
        this.showFlag = false
        this.setStorage("time", "close")
        this.$emit('close-banner')
      },

      setStorage (key, stringVal, time) {
        try {
          // if(!localStorage){return false;}
          if(!time || isNaN(time)) {
            // time=2*60
            time = 1*24*60*60
          }
          let cacheExpireDate = (new Date()-1)+time*1000
          let cacheVal = {
            val: stringVal,
            exp: cacheExpireDate
          }
          localStorage.setItem(key, JSON.stringify(cacheVal));//存入缓存值
          //console.log(key+":存入缓存，"+new Date(cacheExpireDate)+"到期");
        } catch(e) {}
      },

      getStorage (key) {
        try{
          // if(!localStorage){return false;}
          var cacheVal = localStorage.getItem(key)
          var result = JSON.parse(cacheVal)
          var now = new Date()-1
          if (!result) {//缓存不存在
            return null
          }
          if (now > result.exp) {//缓存过期
            this.removeStorage(key)
            return ""
          }
          //console.log("get cache:"+key);
          return result.val
        }catch(e){
          this.removeStorage(key);
          return null;
        }
      },

      removeStorage (key) {
        // if(!localStorage){return false;}
        localStorage.removeItem(key)
      },
      
      permissionAction () {
        window.location.href = `/article?articleId=1048753`
      },

      ruleAction () {
        window.location.href = `/rule`
      }
    }
  }
</script>

<style lang="stylus">
@import '../../common/styl/global.styl'

.download-banner-box
  width 100%
  height rem(99)
  // line-height rem(70)
  background #E1E1E1
  // // background #ff0000
  box-shadow 0 rem(-2) rem(6) rgba(0, 0, 0, .12)
  box-sizing border-box
  position fixed
  left 0
  z-index 99
  &.bottom
    bottom 0
  &.top
    top 0
    .download-banner
      background #F0F0F0

  .download-banner
    height rem(70)
    line-height rem(70)
    line-height rem(70)
    background #FFFFFF
    box-sizing border-box
    clearfix()
    
    .fix-l
      float left
      width rem(40)
      height rem(70)
      line-height rem(70)
      text-align center
      font-size 0
      margin-right rem(-40)
      .close-box
        display inline-block
        width rem(22)
        height rem(22)
        position relative
        top rem(24)
        .close
          position relative
          // top rem(10)
          // left rem(2)
          width rem(18)
          height rem(1.5)
          background #4D4D4D
          transform rotateZ(45deg)
          &:after
            content ""
            background #4D4D4D
            display block
            width rem(18)
            height rem(1.5)
            // position absolute
            // top 0
            // left 0
            transform rotateZ(90deg)
    .fluid-wrap
      float left
      margin-left rem(40)
      margin-right rem(100)
      .fluid-box
        width 100%
        height rem(70)
        .logo-box
          display inline-block
          width rem(44)
          height rem(44)
          // vertical-align middle
          float left
          margin-top rem(13)
          .logo
            width 100%
        .text-box
          display inline-block
          width rem(180)
          margin-left rem(10)
          margin-top rem(17)
          .text
            width 100%
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            font-weight bold
            margin 0
            padding 0
            letter-spacing rem(1)
            &.title
              font-size rem(14)
              color #2B2B2B
              line-height rem(20)
            &.content
              font-size rem(11)
              color #4D4D4D
              line-height rem(16)

    .fix-r
      float right
      width rem(100)
      height rem(70)
      line-height rem(70)
      font-size 0
      margin-left rem(-100)
      text-align center
      .download-btn
        position absolute
        // top 50%
        // transform translateY(-50%)
        top rem(18)
        right rem(12)

  .download-prompt
    width 100%
    height rem(28)
    line-height rem(28)
    margin-top rem(1.1)
    background #ffffff
    color #9A9A9A
    font-size rem(9)
    text-align center
    .prompt-link
      text-decoration underline

</style>



// WEBPACK FOOTER //
// index.vue?57dbcba1